<template>
  <div class="manage-section">
    <div class="current-title">图斑监测管理</div>
    <div class="search-wrap">
      <el-select
        v-model="search.keyword"
        filterable
        allow-create
        default-first-option
        clearable
        placeholder="请输入野外编号"
        style="width: 260px; margin-right: 10px;"
        @change="getList"
        @clear="getList"
      >
        <el-option
          v-for="item in spotOptions"
          :key="item.id"
          :label="item.fieldNo + ' - ' + item.name"
          :value="item.fieldNo"
        ></el-option>
      </el-select>
      <el-button type="primary" @click="getList">查询</el-button>
      <el-button type="success" @click="openAdd">新建监测任务</el-button>
      <el-tag v-if="spotFilter" closable @close="clearSpotFilter" style="margin-left: 10px;">
        {{ spotFilter.fieldNo }} - {{ spotFilter.name }}
      </el-tag>
    </div>
    <div class="table-wrap">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="id" label="序号" width="80"></el-table-column>
        <el-table-column prop="fieldNo" label="野外编号"></el-table-column>
        <el-table-column prop="spotName" label="名称"></el-table-column>
        <el-table-column prop="area" label="面积(㎡)"></el-table-column>
        <el-table-column prop="monitorType" label="监测类型" width="120"></el-table-column>
        <el-table-column label="当前阶段" width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.year }} {{ scope.row.stageLabel }}</span>
          </template>
        </el-table-column>
        <el-table-column label="数据" width="220">
          <template slot-scope="scope">
            <div v-if="scope.row.monitorType == '复绿植被成活率监测'">
              <div>复绿植被成活率 {{ scope.row.survivalRate }}%</div>
              <div>植被成活数 {{ scope.row.survivalCount != null ? scope.row.survivalCount : '-' }}株</div>
            </div>
            <div v-else-if="scope.row.monitorType == '土壤监测'">土壤质量达标率 {{ scope.row.soilRate }}%</div>
            <div v-else-if="scope.row.monitorType == '水样监测'">水样质量达标率 {{ scope.row.waterRate }}%</div>
            <div v-else-if="scope.row.monitorType == '植被覆盖率监测'">植被覆盖率 {{ scope.row.coverageRate }}%</div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column prop="updateTime" label="修改时间"></el-table-column>
        <el-table-column prop="createByName" label="创建人"></el-table-column>
        <el-table-column prop="updateByName" label="修改人"></el-table-column>
        <el-table-column label="操作" width="220">
          <template slot-scope="scope">
            <el-button size="mini" @click="goDetail(scope.row)">详情</el-button>
            <el-button size="mini" @click="openEdit(scope.row)">修改</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pager-wrap">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="search.pageIndex"
        :page-size="search.pageSize"
        layout="total, prev, pager, next"
        :total="totalCount"
      ></el-pagination>
    </div>

    <!-- 底部悬浮汇总柱状图 -->
    <div v-if="search.spotId" class="floating-chart" :class="{ collapsed: chartCollapsed }">
      <div class="chart-header" @click="chartCollapsed = !chartCollapsed">
        <span class="chart-title">历年监测汇总</span>
        <i :class="chartCollapsed ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
      </div>
      <div v-show="!chartCollapsed" class="chart-body">
        <div ref="chartContainer" style="width: 100%; height: 220px;"></div>
      </div>
    </div>

    <add-spot-task :visible.sync="dialogVisible" :data="currentRow" @success="getList" />
  </div>
</template>

<script>
import addSpotTask from "./components/addSpotTask.vue";

export default {
  components: { addSpotTask },
  data() {
    return {
      search: {
        keyword: "",
        pageIndex: 1,
        pageSize: 10,
        spotId: null
      },
      tableData: [],
      totalCount: 0,
      dialogVisible: false,
      currentRow: null,
      chartCollapsed: false,
      chartInstance: null,
      chartData: [],
      spotFilter: null,
      spotOptions: []
    };
  },
  created() {
    const spotId = this.$route.query.spotId;
    if (spotId) {
      this.search.spotId = parseInt(spotId);
      this.loadSpotInfo(this.search.spotId);
    }
    this.loadSpots();
    this.getList();
    if (this.search.spotId) {
      this.loadChartData();
    }
  },
  mounted() {
    if (this.search.spotId && this.chartData.length > 0) {
      this.$nextTick(() => {
        this.renderChart();
      });
    }
  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.dispose();
      this.chartInstance = null;
    }
  },
  methods: {
    loadSpots() {
      this.$apis.get("/admin/spot/list").then(res => {
        if (res.data.code == 200) {
          this.spotOptions = res.data.data || [];
        }
      });
    },
    getList() {
      this.$apis.get("/admin/spotTask/page", this.search).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.list || [];
          this.totalCount = res.data.data.totalCount || 0;
        }
      });
    },
    handleCurrentChange(val) {
      this.search.pageIndex = val;
      this.getList();
    },
    openAdd() {
      this.currentRow = null;
      this.dialogVisible = true;
    },
    openEdit(row) {
      this.currentRow = row;
      this.dialogVisible = true;
    },
    handleDelete(row) {
      this.$confirm("确认删除该监测任务？", "提示", { type: "warning" }).then(() => {
        this.$apis.post("/admin/spotTask/delete", { id: row.id }).then(res => {
          if (res.data.code == 200) {
            this.$message.success("删除成功");
            this.getList();
          } else {
            this.$message.error(res.data.msg || "删除失败");
          }
        });
      });
    },
    goDetail(row) {
      this.$router.push({ path: "/spotMonitorDetail", query: { id: row.id, spotId: row.spotId } });
    },
    loadSpotInfo(spotId) {
      if (!spotId) return;
      this.$apis.get("/admin/spot/detail/" + spotId).then(res => {
        if (res.data.code == 200) {
          this.spotFilter = res.data.data || null;
        }
      });
    },
    clearSpotFilter() {
      this.search.spotId = null;
      this.spotFilter = null;
      this.search.pageIndex = 1;
      this.getList();
      if (this.chartInstance) {
        this.chartInstance.dispose();
        this.chartInstance = null;
      }
      this.chartData = [];
    },
    loadChartData() {
      if (!this.search.spotId) return;
      this.$apis.get("/admin/spot/stage/statistics", { spotId: this.search.spotId }).then(res => {
        if (res.data.code == 200) {
          this.chartData = res.data.data || [];
          this.$nextTick(() => {
            this.renderChart();
          });
        }
      });
    },
    renderChart() {
      if (!this.$refs.chartContainer) return;
      if (this.chartInstance) {
        this.chartInstance.dispose();
      }
      this.chartInstance = window.echarts.init(this.$refs.chartContainer);
      const years = this.chartData.map(d => d.year + "年");
      const option = {
        tooltip: { trigger: "axis", axisPointer: { type: "shadow" } },
        legend: {
          data: ["植被覆盖率(%)", "植被成活率(%)", "土壤质量达标率(%)", "水量质量达标率(%)", "危岩体数(个)"],
          bottom: 0,
          textStyle: { fontSize: 11 }
        },
        grid: { left: "3%", right: "4%", bottom: "18%", top: "10%", containLabel: true },
        xAxis: { type: "category", data: years, axisLabel: { fontSize: 11 } },
        yAxis: { type: "value", axisLabel: { fontSize: 11 } },
        series: [
          { name: "植被覆盖率(%)", type: "bar", data: this.chartData.map(d => d.vegetationCoverage) },
          { name: "植被成活率(%)", type: "bar", data: this.chartData.map(d => d.vegetationSurvivalRate) },
          { name: "土壤质量达标率(%)", type: "bar", data: this.chartData.map(d => d.soilQualityRate) },
          { name: "水量质量达标率(%)", type: "bar", data: this.chartData.map(d => d.waterQualityRate) },
          { name: "危岩体数(个)", type: "bar", data: this.chartData.map(d => d.dangerRockCount) }
        ]
      };
      this.chartInstance.setOption(option);
    }
  }
};
</script>

<style scoped>
.floating-chart {
  position: fixed;
  bottom: 0;
  left: 200px;
  right: 0;
  background: #fff;
  box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
  z-index: 100;
  transition: all 0.3s;
}
.floating-chart.collapsed {
  height: auto;
}
.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  background: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  color: #303133;
}
.chart-body {
  padding: 8px 16px;
}
</style>



// WEBPACK FOOTER //
// src/page/spotMonitorManage.vue